import config from '../config';
import createAuthorizedClient from './createAuthorizedClient';

const Axios = createAuthorizedClient(config.apiUrl.concat('api/configuration/'));

export default Axios;
